// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"350":"setup","463":"features"}[chunkId] || chunkId) + "." + __webpack_require__.h() + ".js";
};